module.exports = __webpack_public_path__ + "static/pl-rate-drop-3-adde7080562d8c3ba9102739055be8e0.jpg";